define("shared/utils/formatters/fb-post-from-dynamo", ["exports", "later/models/fb-post"], function (_exports, _fbPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/fb-post"eaimeta@70e063a35619d71f
  /**
   * Converts a raw facebook dynamo post into a DynamoFbPost
   *
   */
  function createFacebookPostFromDynamo(obj, socialProfile) {
    const reactionsByType = [];
    const engagements = (obj.reactions ?? 0) + (obj.clicks ?? 0) + (obj.comments ?? 0) + (obj.shares ?? 0);
    if (obj.reactions_by_type) {
      Object.entries(obj.reactions_by_type || {}).forEach(_ref => {
        let [type, percentage] = _ref;
        reactionsByType.push({
          type: type,
          percentage: Number(percentage)
        });
      });
    }
    return new _fbPost.default({
      socialProfile,
      id: obj.id,
      pageId: obj.page_id,
      isPopular: obj.is_popular,
      isPublished: obj.is_published,
      isHidden: obj.is_hidden,
      isExpired: obj.is_expired,
      message: obj.message,
      createdTime: obj.created_time,
      updatedTime: obj.updated_time,
      updatedAt: obj.updated_at,
      permalinkUrl: obj.permalink_url,
      fullPicture: obj.full_picture,
      timelineVisibility: obj.timeline_visibility,
      properties: obj.properties,
      statusType: obj.status_type,
      type: obj.type,
      privacy: obj.privacy,
      imageUrl: obj.permanent_image_url || obj.full_picture,
      isVideo: obj.type === 'video_inline',
      ineligibleForInsights: obj.ineligible_for_insights,
      impressions: obj.impressions,
      clicks: obj.clicks,
      reach: obj.reach,
      views: obj.media_view_total,
      likes: obj.likes,
      engagements,
      reactions: obj.reactions,
      reactionsByType,
      videoViews: obj.video_views,
      videoViewsUnique: obj.video_views_unique,
      comments: obj.comments,
      shares: obj.shares,
      standardResUrl: obj.permanent_image_url
    });
  }
  var _default = _exports.default = createFacebookPostFromDynamo;
});